export function IconRefreshCw() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 4V10M23 10H17M23 10L18.36 5.64C17.2853 4.56471 15.9556 3.77921 14.4952 3.35677C13.0348 2.93434 11.4911 2.88875 10.0083 3.22426C8.52547 3.55976 7.1518 4.26543 6.01547 5.27542C4.87913 6.2854 4.01717 7.56678 3.51 9M1 20V14M1 14H7M1 14L5.64 18.36C6.71475 19.4353 8.04437 20.2208 9.50481 20.6432C10.9652 21.0657 12.5089 21.1112 13.9917 20.7757C15.4745 20.4402 16.8482 19.7346 17.9845 18.7246C19.1209 17.7146 19.9828 16.4332 20.49 15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
